import apiClient from './apiClient';

// ============================================================
// M302 - 庫位庫存量表 API types and client
// ============================================================

export interface M302ReportRow {
  fm030_01: string;       // 庫位代號
  fm030_02: string;       // 產品代號
  fm030_03: string;       // 批號
  fm030_12: string;       // 計量單位代號
  fm030_13: string | null; // 入庫日期
  fm030_16: number;       // 庫存數量
  fm030_17: number;       // 庫存金額
  unit_price: number;     // 平均單價
  fm030_24: number;       // 附加數值1
  fm030_25: number;       // 附加數值2
  fm030_26: number;       // 附加數值3
  fm030_27: number;       // 附加數值4
  loc_name: string;       // 庫位名稱
  prod_name: string;      // 產品名稱
  unit_name: string;      // 計量單位名稱
}

export interface M302SubtotalRow {
  fm030_01: string;  // 庫位代號
  fm030_12: string;  // 計量單位代號
  quantity: number;  // 小計數量
  amount: number;    // 小計金額
}

export interface M302GrandTotalRow {
  fm030_12: string;  // 計量單位代號
  quantity: number;  // 合計數量
  amount: number;    // 合計金額
}

export interface M302ReportResponse {
  items: M302ReportRow[];
  subtotals: M302SubtotalRow[];
  grandTotals: M302GrandTotalRow[];
  total: number;
}

export interface M302ReportParams {
  startWarehouse?: string;
  lastWarehouse?: string;
  startProduct?: string;
  lastProduct?: string;
  startBatch?: string;
  lastBatch?: string;
  startDate?: string;
  lastDate?: string;
  excludeZero?: boolean;
}

export const m302Api = {
  async query(params: M302ReportParams): Promise<M302ReportResponse> {
    const body: Record<string, unknown> = {};
    if (params.startWarehouse) body.startWarehouse = params.startWarehouse;
    if (params.lastWarehouse)  body.lastWarehouse  = params.lastWarehouse;
    if (params.startProduct)   body.startProduct   = params.startProduct;
    if (params.lastProduct)    body.lastProduct    = params.lastProduct;
    if (params.startBatch)     body.startBatch     = params.startBatch;
    if (params.lastBatch)      body.lastBatch      = params.lastBatch;
    if (params.startDate)      body.startDate      = params.startDate;
    if (params.lastDate)       body.lastDate       = params.lastDate;
    if (params.excludeZero !== undefined) body.excludeZero = params.excludeZero;

    return (await apiClient.post('/api/m302/query', body)).data;
  },
};
